import qs from 'qs';
export const transformers = {
    mapLabels: (mapping) => (items) => (!items ? [] : items.map((item) => (Object.assign(Object.assign({}, item), { label: mapping[item.label] || item.label, data: transformers.mapNullableLabels(mapping)(item.data || null) })))),
    mapValues: (mapping) => (items) => (!items ? [] : items.map((item) => (Object.assign(Object.assign({}, item), { label: mapping[item.value] || item.label, data: transformers.mapNullableValues(mapping)(item.data || null) })))),
    uppercase: (items) => (!items ? [] : items.map((item) => (Object.assign(Object.assign({}, item), { label: item.label.toUpperCase(), data: transformers.uppercaseNullable(item.data || null) })))),
    mapNullableLabels: (mapping) => (items) => (!items ? items : items.map((item) => (Object.assign(Object.assign({}, item), { label: mapping[item.label] || item.label, data: transformers.mapNullableLabels(mapping)(item.data || null) })))),
    mapNullableValues: (mapping) => (items) => (!items ? items : items.map((item) => (Object.assign(Object.assign({}, item), { label: mapping[item.value] || item.label, data: transformers.mapNullableValues(mapping)(item.data || null) })))),
    uppercaseNullable: (items) => (!items ? items : items.map((item) => (Object.assign(Object.assign({}, item), { label: item.label.toUpperCase(), data: transformers.uppercaseNullable(item.data || null) })))),
};
export const sorters = {
    numeric: (item1, item2) => {
        let value1 = parseInt(item1.escapedValue, 10);
        let value2 = parseInt(item2.escapedValue, 10);
        if (!Number.isNaN(value1) && Number.isNaN(value2)) {
            return 1;
        }
        if (Number.isNaN(value1) && !Number.isNaN(value2)) {
            return -1;
        }
        if (Number.isNaN(value1)) {
            value1 = item1.escapedValue;
        }
        if (Number.isNaN(value2)) {
            value2 = item2.escapedValue;
        }
        if (value1 > value2) {
            return 1;
        }
        if (value1 < value2) {
            return -1;
        }
        return 0;
    },
};
export const query = {
    queryStringToFilters: (queryString, mapping = {}) => {
        const result = {};
        const q = qs.parse(queryString);
        const legacyFilters = Object.assign(Object.assign(Object.assign(Object.assign({}, (q['dFR'] || {})), (q['fR'] || {})), (q['nR'] || {})), (q['idx'] ? { sortBy: q['idx'] } : {}));
        const filters = Object.keys(legacyFilters).length > 0 ? legacyFilters : q;
        Object.keys(filters).forEach((attribute) => {
            const key = mapping[attribute] || attribute;
            const values = filters[attribute] || [];
            result[key] = (Array.isArray(values) ? values : [values])
                .filter(Boolean)
                .map(query.decodeURIComponent);
        });
        return result;
    },
    decodeURIComponent(encodedURIComponent) {
        try {
            return decodeURIComponent(encodedURIComponent);
        }
        catch (_) {
            /**
             * By default, percentage character (%) is not encoded.
             * Following function should find single percentage character (%),
             * not followed by two hexadecimal digits and encode it.
             */
            return decodeURIComponent(encodedURIComponent.replace(/%(?![0-9a-fA-F]{2})/g, '%25'));
        }
    },
};
export const states = {
    flatUiState(uiState) {
        const result = {};
        if (!uiState) {
            return result;
        }
        Object.keys(uiState).forEach((index) => {
            const indexState = uiState[index];
            if (indexState) {
                if (indexState.query) {
                    result['query'] = indexState.query;
                }
                if (indexState.page) {
                    result['page'] = indexState.page;
                }
                if (indexState.sortBy) {
                    result['sortBy'] = indexState.sortBy;
                }
                if (indexState.refinementList) {
                    Object.keys(indexState.refinementList).forEach((attribute) => {
                        result[attribute] = indexState.refinementList
                            ? indexState.refinementList[attribute]
                            : undefined;
                    });
                }
                if (indexState.menu) {
                    Object.keys(indexState.menu).forEach((attribute) => {
                        result[attribute] = indexState.menu
                            ? indexState.menu[attribute]
                            : undefined;
                    });
                }
                if (indexState.hierarchicalMenu) {
                    Object.keys(indexState.hierarchicalMenu).forEach((attribute) => {
                        result[attribute] = indexState.hierarchicalMenu
                            ? indexState.hierarchicalMenu[attribute]
                            : undefined;
                    });
                }
                if (indexState.range) {
                    Object.keys(indexState.range).forEach((attribute) => {
                        result[attribute] = indexState.range
                            ? indexState.range[attribute]
                            : undefined;
                    });
                }
            }
        });
        return result;
    },
};
export const html = {
    decode(encodedString) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = encodedString;
        return textarea.value;
    },
};
